import { TFunction } from 'i18next';

const getRegionsData = (t: TFunction) => [
    { value: 'N', label: t('Norte') },
    { value: 'NE', label: t('Nordeste') },
    { value: 'SE', label: t('Sudeste') },
    { value: 'S', label: t('Sul') },
    { value: 'CO', label: t('CentroOeste') },
];

export default getRegionsData;
